function Policy () {

    return(
        <section className="flex flex-col items-center py-14 px-6 bg-beige-light">
            <div className="space-y-4">
        <h2 className="text-3xl md:text-3xl font-serif mb-8">Integritetspolicy</h2>
        <p className="leading-relaxed md:leading-normal ">
            Vi värnar om din personliga integritet. <br/>
            <br/>
            Vår webbplats samlar inte in personuppgifter direkt via formulär. Bokningar sker via en extern bokningstjänst som har eget ansvar för hantering av personuppgifter.<br/>
            <br/>
            Webbplatsen är hostad via Netlify, vilket innebär att teknisk information såsom IP-adresser kan loggas automatiskt för säkerhet och drift.<br/>
            <br/>
            Vi säljer eller delar inte personuppgifter.<br/>
            <br/>
            Om du har frågor kring personuppgifter är du välkommen att kontakta oss på: <b><a href="mailto:info@studioclaire.se">info@studioclaire.se</a></b>
            </p>
    </div>
</section>
    );
}

export default Policy;